import { connect } from "react-redux";
import React, { useState } from "react";
import axios from "axios";
import { checkCeleryTaskStatus, dataURItoBlob } from "../../_utils/common";
import { StoryTypes } from "../../_utils/constants";
import { PROJECTS } from "../../_utils/routes";
import { captureAndUpdateCover } from "../../_actions/storiesActions";
import { withRouter } from "react-router-dom";
import { EditProjectName, SaveAsTemplate } from "../common/statelessView";
import format from "string-format";
import { EXPORT_VIDEO } from "../../_actions/endpoints";
import { FeatureCodes } from "../details/constants";
import connectedFeatureAvailabilityWrapper from "./withFeatureAvailability";
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FaCog } from "react-icons/fa";
import { Modal } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { showToast } from "../../_utils/showToast";
import PostsBulkImportModal from "../social/PostsBulkImport/PostsBulkImportModal";
import BulkArtboardCreationModal from "./modals/BulkArtboardCreationModal";

const StoryNameDropDown = (props) => {
  const { t } = useTranslation(["navbar", "common", "billing"]);
  const {
    story: {
      payload: { story_type },
    },
    story,
    match: {
      params: { designId },
    },
  } = props;
  const signal = axios.CancelToken.source();
  const [openSaveAsTemplateDialog, setOpenSaveAsTemplateDialog] =
    useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [openRenameProjectDialog, setOpenRenameProjectDialog] = useState(false);
  const [openBulkCreationDialog, setOpenBulkCreationDialog] = useState(false);
  const showFailedMessage = (message = t("export_failed_message")) => {
    showToast({
      description: message,
      title: t("error", { ns: "common" }),
      status: "error",
    });
  };

  const renderingTracker = async (taskId) => {
    try {
      const result = await checkCeleryTaskStatus(taskId, () => {});
      if (result.response.status === "SUCCESS") {
        if (result.response.info.jobId) {
          showToast({
            description: t("export_finishing_touch_message"),
            title: t("export_waiting_message"),
            status: "info",
          });

          renderingTracker(result.response.info.jobId);
        } else {
          const url =
            result.response.info?.zipped_file ||
            result.response.info?.urls?.[0] ||
            "";

          setVideoPreviewUrl(url);
          setIsExporting(false);
        }
      } else {
        showFailedMessage();
        setIsExporting(false);
        setErrorMessage(t("video_preview_error_message"));
      }
    } catch (err) {
      showFailedMessage();
      setIsExporting(false);
      setErrorMessage(t("video_preview_error_message"));
    }
  };

  const exportVideo = async () => {
    try {
      const exportResponse = await axios.post(
        format(EXPORT_VIDEO, story.payload.id),
        { type: "video" }
      );
      const result = await checkCeleryTaskStatus(
        exportResponse.data.id,
        () => {}
      );
      if (result.response.status === "SUCCESS") {
        showToast({
          description: t("render_wait_message"),
          title: t("render_message"),
          status: "info",
        });

        renderingTracker(result.response.info.jobId);
      } else {
        showFailedMessage();
        setIsExporting(false);
        setErrorMessage(t("video_preview_error_message"));
      }
    } catch (err) {
      showFailedMessage();
      setIsExporting(false);
      setErrorMessage(t("video_preview_error_message"));
    }
  };
  const menuItemStyles = {
    _hover: {
      color: "primary.300",
      background: "none",
    },
  };

  const OptionsDropdown = ({ props }) => {
    return (
      <Menu isLazy autoSelect={false}>
        <MenuButton as={IconButton} icon={<FaCog />} size="sm" fontSize="lg" />
        <MenuList minW={0}>
          <MenuItem
            onClick={openRenameDialog}
            sx={menuItemStyles}
            color="gray.300"
          >
            {t("navbar.storyname.dropdown.rename")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              props.checkFeatureAvailability(
                FeatureCodes.SAVE_AS_TEMPLATE,
                () => saveAsTemplate()
              );
            }}
            sx={menuItemStyles}
            color="gray.300"
          >
            {t("navbar.storyname.dropdown.save")}
          </MenuItem>
          {props.userPermissions.indexOf("enterprise_user_feature") > -1 && (
            <MenuItem
              onClick={openCloseBulkDialog}
              sx={menuItemStyles}
              color="gray.300"
            >
              {t("navbar.storyname.dropdown.bulkCreation")}
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    );
  };

  const saveAsTemplate = () => {
    setOpenSaveAsTemplateDialog(true);
    if (story_type === StoryTypes.ANIMATED) {
      // If the story is animated start exporting video for the preview
      setIsExporting(true);
      exportVideo();
    }
  };

  const closeModal = () => {
    setOpenSaveAsTemplateDialog(false);
    setIsExporting(false);
    setVideoPreviewUrl(null);
    setErrorMessage(null);
  };

  const openRenameDialog = () => {
    setOpenRenameProjectDialog(true);
  };

  const openCloseBulkDialog = () => {
    setOpenBulkCreationDialog(!openBulkCreationDialog);
  };

  const setStoryPageCover = (
    props,
    storyId,
    pageId,
    saveAsTemplate,
    templateName
  ) => {
    const { canvasRef } = props.props;
    let imageQuality = 0.2;
    let fileType = "jpeg";

    let fileName = `${pageId}_${Date.now()}.${fileType}`;

    const dataURL = canvasRef.handler.getArtBoardAsDataURL({
      format: fileType,
      quality: imageQuality,
      name: fileName,
    });

    if (!dataURL) {
      showToast({
        description: t("error_message"),
        title: t("cover_error_message"),
        status: "error",
      });

      props.props.backToDashboard();
      props.props.redirect(PROJECTS, props);
      return;
    }

    let file = new File([dataURItoBlob(dataURL)], fileName, {
      type: "image/jpeg",
    });
    const video = videoPreviewUrl;

    props.captureAndUpdateCover(
      storyId,
      file,
      saveAsTemplate,
      signal,
      {
        ...props.props,
      },
      templateName,
      video
    );
    closeModal();
  };

  return (
    <>
      <OptionsDropdown props={props}></OptionsDropdown>
      <Modal
        isOpen={openSaveAsTemplateDialog}
        onClose={(e) => closeModal()}
        size={story_type === StoryTypes.ANIMATED ? "md" : "sm"}
        isCentered
      >
        <SaveAsTemplate
          props={props}
          handleCloseAddModal={(e) => closeModal()}
          signal={signal}
          onSubmit={setStoryPageCover}
          isExportingPreview={isExporting}
          previewUrl={videoPreviewUrl}
          errorMessage={errorMessage}
        ></SaveAsTemplate>
      </Modal>
      <Modal
        isOpen={openRenameProjectDialog}
        onClose={(e) => setOpenRenameProjectDialog(false)}
        size="sm"
        isCentered
      >
        <EditProjectName
          props={props.props}
          handleCloseAddModal={(e) => setOpenRenameProjectDialog(false)}
          signal={signal}
        ></EditProjectName>
      </Modal>
      {openBulkCreationDialog && (
        <BulkArtboardCreationModal
          designId={designId}
          onClose={openCloseBulkDialog}
        />
      )}
    </>
  );
};

StoryNameDropDown.propTypes = {};

const mapStateToProps = (state) => ({
  story: state.story,
  subscription: state.subscription,
  userPermissions: state.auth.payload.user.role.permissions,
});

const mapDispatchToProps = (dispatch) => ({
  captureAndUpdateCover: (
    storyId,
    file,
    saveAsTemplate,
    signal,
    props,
    templateName,
    videoUrl = null
  ) =>
    dispatch(
      captureAndUpdateCover(
        storyId,
        file,
        saveAsTemplate,
        signal,
        props,
        templateName,
        videoUrl
      )
    ),
});

export default connectedFeatureAvailabilityWrapper(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(StoryNameDropDown))
);
